import { render, staticRenderFns } from "./ProductCardReplacement.vue?vue&type=template&id=5b52c575"
import script from "./ProductCardReplacement.vue?vue&type=script&lang=js"
export * from "./ProductCardReplacement.vue?vue&type=script&lang=js"
import style0 from "./ProductCardReplacement.vue?vue&type=style&index=0&id=5b52c575&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports